import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../theme';

const OPTS = [['light', Sun], ['dark', Moon], ['system', Monitor]];

export const ThemeToggle = () => {
  const { mode, setMode } = useTheme();
  return (
    <div data-testid="theme-selector" className="flex items-center rounded-full border border-navy/15 dark:border-white/20 p-0.5">
      {OPTS.map(([m, Icon]) => (
        <button
          key={m}
          data-testid={`theme-${m}`}
          onClick={() => setMode(m)}
          aria-label={`${m} mode`}
          title={`${m.charAt(0).toUpperCase() + m.slice(1)} mode`}
          className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
            mode === m ? 'bg-ember text-navy' : 'text-navy/55 dark:text-white/55 hover:text-navy dark:hover:text-white'
          }`}
        >
          <Icon size={15} strokeWidth={1.8} />
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
